export const environment = {
    production: true,
    env: 'prod',
    cryptoSecretKey: '$2y$12$IU.ooOzWZh/oiPGSkO4PE.hIGeoOTlo3v6Z14MgdGbwfop9R7rggm',
    meetingURL: 'https://meetings.hub.finstein.de/meetings/saskia-soezeri/supportmeeting',
    copMeetingURL: 'https://meetings.hub.finstein.de/meetings/saskia-soezeri/supportmeeting',
    bookDemoMeetingURL: 'https://meetings.hub.finstein.de/meetings/nicoleneubauer/demo?embed=true',
    bookDemoMeetingFacebookURL: 'https://meetings.hub.finstein.de/meetings/saskia-soezeri/facebook-ad-demo-meeting-?embed=true',
    firebaseConfig: {
        apiKey: 'AIzaSyBLCblg-x-m5VdexpkyEJ8cTgDe04tp5wQ',
        authDomain: 'finstein-prod.firebaseapp.com',
        databaseURL: 'https://finstein-rt-prod.europe-west1.firebasedatabase.app/',
        projectId: 'finstein-prod',
        storageBucket: 'finstein-prod.appspot.com',
        messagingSenderId: '1099266028967',
        appId: '1:1099266028967:web:abcaf1cd5b9c1c7327b282',
        measurementId: 'G-YFMDH3G8KT',
    },
    reCaptchaConfigs: {
        siteKey: '6Lc2SEggAAAAAJyOTHVpvYMkwNLubvNODWTMSf1Q'
    },
    portalBaseURL: 'https://portal.finstein.de',
    bvmwCertificateURL: 'https://www.bvmw.de/',
    websiteBaseURL: 'https://finstein.de',
    faqBaseURL: 'https://faq.finstein.de',
    copBaseURL: 'https://beratungsprozess.finstein.de',
    authExpirationTime: 1800, // 30min
    authRecoveryTime: 30 // seconds
};
